import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useEnhancedAuth } from '../../contexts/EnhancedAuthContext';
import { SUBSCRIPTION_ENDPOINTS, STORAGE_KEYS } from '../../constants/api';
import styles from '../../styles/PaymentRetry.module.css';

const PaymentRetry: React.FC = () => {
  const navigate = useNavigate();
  const { userDetails } = useEnhancedAuth();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handlePayWithPayFast = async () => {
    setIsProcessing(true);
    setError(null);
    try {
      const token = sessionStorage.getItem(STORAGE_KEYS.TOKEN);
      const { data } = await axios.post(
        SUBSCRIPTION_ENDPOINTS.CREATE_PAYMENT,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Build a hidden form and submit to PayFast
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = data.payfastUrl;
      Object.entries(data.params).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Failed to initiate payment. Please try again.');
      setIsProcessing(false);
    }
  };

  const packagePrice = userDetails?.agency?.packagePrice || 299;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>Renew Your Subscription</h1>
          <p className={styles.subtitle}>
            Complete your payment to restore access to your agency "{userDetails?.agency?.companyName}"
          </p>
        </header>

        <div className={styles.paymentContainer}>
          <div className={styles.packageInfo}>
            <h3 className={styles.packageTitle}>Agency Package</h3>
            <div className={styles.packageDetails}>
              <div className={styles.packageItem}>
                <span>Monthly Subscription</span>
                <span className={styles.price}>R{packagePrice}</span>
              </div>
              <div className={styles.packageItem}>
                <span>Number of Seats</span>
                <span>{userDetails?.agency?.numberOfSeats || 1}</span>
              </div>
              <div className={styles.packageDivider}></div>
              <div className={styles.packageItem}>
                <span className={styles.totalLabel}>Total Due</span>
                <span className={styles.totalPrice}>R{packagePrice}</span>
              </div>
            </div>
          </div>

          <div className={styles.paymentForm}>
            <p style={{ fontSize: 14, color: '#64748b', marginBottom: 24 }}>
              You will be securely redirected to PayFast to complete your payment. 
              PayFast supports credit/debit cards, instant EFT, and more.
            </p>

            {error && (
              <p style={{ color: '#dc2626', fontSize: 14, marginBottom: 16 }}>{error}</p>
            )}

            <div className={styles.actions}>
              <button
                type="button"
                disabled={isProcessing}
                className={styles.payButton}
                onClick={handlePayWithPayFast}
              >
                {isProcessing ? 'Redirecting…' : `Pay R${packagePrice} via PayFast`}
              </button>

              <Link to="/contact-support" className={styles.supportLink}>
                Need help with payment?
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.backAction}>
          <Link to="/" className={styles.backButton}>
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentRetry;